import { get } from "lodash";

export class DeclarationForm {
  policy: boolean | undefined;
  summary: boolean | undefined;
  term: boolean | undefined;
  declaration: boolean | undefined;
  ped: boolean | undefined;
  benefit: boolean | undefined;
  dpi: boolean | undefined;
  completed: boolean | undefined;
  assured: boolean | undefined;
  understand: boolean | undefined;
  completedDPI: boolean | undefined;
  usedEstimator: boolean | undefined;
  usedBudgetCalculator: boolean | undefined;
  visitedCompareFirst: boolean | undefined;
  considerDiffDPI: boolean | undefined;

  constructor(initial: any) {
    this.policy = get(initial, "policy", undefined);
    this.summary = get(initial, "summary", undefined);
    this.term = get(initial, "term", undefined);
    this.ped = get(initial, "ped", undefined);
    this.dpi = get(initial, "dpi", undefined);
    this.benefit = get(initial, "benefit", undefined);
    this.completed = get(initial, "completed", undefined);
    this.understand = get(initial, "understand", undefined);
    this.assured = get(initial, "assured", undefined);
    this.completedDPI = get(initial, "completedDPI", undefined);
    this.usedEstimator = get(initial, "usedEstimator", undefined);
    this.usedBudgetCalculator = get(initial, "usedBudgetCalculator", undefined);
    this.visitedCompareFirst = get(initial, "visitedCompareFirst", undefined);
    this.considerDiffDPI = get(initial, "considerDiffDPI", undefined);
  }

  get reviewDeclaration(): { text: string; value: string; children?: any[] }[] {
    return [
      {
        text: "I have downloaded, fully read and understood the cover page and policy illustration",
        value: this.policy ? "Yes" : "No",
      },
      {
        text: "I have downloaded, fully read and understood the product summary",
        value: this.summary ? "Yes" : "No",
      },
      {
        text: "I have downloaded, fully read and understood the policy terms and conditions",
        value: this.term ? "Yes" : "No",
      },
      {
        text: "I have downloaded, fully read and agreed to the statements described in this online purchase declaration",
        value: this.ped ? "Yes" : "No",
      },
      {
        text: "I have downloaded, fully read and agreed to the statements described in this DPI factsheet",
        value: this.dpi ? "Yes" : "No",
      },
      {
        text: "I am not a Politically Exposed Person (PEP) or a family member/close associate of a PEP",
        value: this.benefit ? "Yes" : "No",
      },
      {
        text: "There is no beneficial ownership arrangement under this application",
        value: this.completed ? "Yes" : "No",
      },
      {
        text: "I have completed and disclosed fully and truthfully all the information requested for in this application",
        value: this.completed ? "Yes" : "No",
      },
      {
        text: "I have",
        value: this.completedDPI ? "Yes" : "No",
        children: [
          "Read and understood the DPI Fact Sheet",
          "Read and understood the Policy Illustration and product summary, including any coverage exclusions of the DPI",
          "Declared all pre-existing medical conditions in the Proposal Form",
          "Disclosed all existing life insurance policies that I own, or am in the process of applying for in the Proposal Form",
          "Declared my current financial situation, such as my income and expenses in the Proposal Form",
          "Completed and disclosed fully and truthfully all the information requested in the Proposal Form and any supplementary questionnaire(s)",
          "Decided to buy the DPI, without seeking any advice from any financial advisory representative",
        ],
      },
      {
        text: "Have you...",
        value: this.completed ? "Yes" : "No",
        children: [
          "Used the Insurance Estimator to calculate the amount of life insurance coverage you would need?",
          "Used the Budget Calculator to check if the premium that you will pay is affordable based on your current income and expenditure?",
          "Visited Comparefirst to compare the features and premiums of DPI and other types of life insurance products?",
          "Considered the different types of DPI and other types of life insurance products that are available, and whether the DPI that you intend to purchase is suitable for your financial circumstances and needs?",
        ],
      },
      {
        text: "I understand that I will receive my policy, any endorsements and communications electronically once they are ready. I understand that I may log on to MySinglife to opt for my preferred document option and may switch between e-documents and printed documents",
        value: this.understand ? "Yes" : "No",
      },
    ];
  }
}

export interface IReadDocs {
  isReadPolicy: boolean;
  isReadProduct: boolean;
  isReadTerms: boolean;
  isReadDeclare: boolean;
  isReadDPI: boolean;
}
